import { Component, Input } from '@angular/core';
import { TooltipPosition } from '@angular/material/tooltip';

@Component({
  selector: 'info-tooltip',
  templateUrl: './info-tooltip.component.html',
  styleUrls: ['./info-tooltip.component.scss'],
  standalone: false,
})
export class InfoTooltipComponent {
  @Input() text = '';
  @Input() tooltipPosition?: TooltipPosition;
}
